/**
 * Created by andrey on 05.10.2020.
 */

const Payments = function (pluginName, options) {
    BasePlugin.call(this, "payments", pluginName, options);

    this.currency = this.getDefaultCurrency();

    this.products = {};
    this.productsById = {};

    this.productsLoaded = false;
    this.bus.on("changeStatus", (status) => {
        if (status !== connector.STATUS_CONNECTED) {
            this.productsLoaded = false;
            this.missingProductsLoadAttempt = 0;
        }
    });
};

Payments.prototype = Object.create(BasePlugin.prototype);
Payments.prototype.constructor = Payments;

Payments.prototype._listConnectTasks = function () {
    return [
        this.loadSdkAndConnect.bind(this),
        this.loadProductsConfig.bind(this)
    ];
};

Payments.prototype.loadProductsConfig = function (callback) {
    if (window.CONNECTOR_PRODUCTS) {
        this.createProducts(window.CONNECTOR_PRODUCTS);
    }

    connector._paymentsManager.loadProductsConfig((productsConfig) => {
        if (productsConfig) {
            this.createProducts(productsConfig);
        }

        if (!productsConfig && window.CONNECTOR_PRODUCTS) {
            console.log("[connector] Failed to load products, falling back to local products");
        }

        if (productsConfig || window.CONNECTOR_PRODUCTS) {
            callback(connector.STATUS_CONNECTED);
        } else {
            callback(connector.STATUS_DISCONNECTED);
        }
    });
};

Payments.prototype.getDefaultCurrency = function () {
    return "USD";
};

Payments.prototype.createProducts = function (productsConfig) {
    this.products = {};
    this.productsById = {};

    for (const key in productsConfig) {
        const product = this.createProduct(key, productsConfig[key]);
        if (product) {
            this.products[product.itemId] = product;
            this.productsById[product.productId] = product;
        }
    }
};

Payments.prototype.createProduct = function (itemId, productConfig) {
    if (typeof productConfig !== "object") {
        return;
    }

    let productId = this.getProductId(productConfig);
    if (productId === null) {
        return;
    }

    if (productId === undefined) {
        productId = itemId;
    }

    const priceUSD = productConfig.price;

    const price = this.convertPrice(priceUSD);
    const textPrice = this.getTextPrice(price);

    const product = {
        itemId,
        type: productConfig.type || "consumable",
        title: productConfig.title,
        description: productConfig.description,
        image: productConfig.image,

        productId: `${productId}`,
        price,
        currency: this.currency,
        priceUSD,
        textPrice
    };

    if (product.type === "subscription") {
        product.trial = productConfig.trial;
        product.period = productConfig.period;
    }

    if (productConfig.currencyImage) {
        product.currencyImage = productConfig.currencyImage;
    }

    return product;
};

Payments.prototype.getProduct = function (productOrItemId) {
    return this.products[productOrItemId] || this.productsById[productOrItemId];
};

Payments.prototype.listProducts = function () {
    return Object.values(this.products);
};

Payments.prototype.listProductIdsOfType = function (types) {
    types = Array.isArray(types) ? types : [types];

    return this.listProducts().filter((product) => types.includes(product.type)).map((product) => product.productId);
};

Payments.prototype.isVirtualCurrency = function () {
    return connector.VIRTUAL_EXCHANGE_RATES[this.currency] !== undefined;
};

Payments.prototype.getExchangeRate = function () {
    let exchangeRate;
    if (this.isVirtualCurrency()) {
        exchangeRate = connector.VIRTUAL_EXCHANGE_RATES[this.currency];
    } else {
        exchangeRate = connector.EXCHANGE_RATES[this.currency];
        if (connector.EXCHANGE_RATES[this.pluginName] && connector.EXCHANGE_RATES[this.pluginName][this.currency]) {
            exchangeRate = connector.EXCHANGE_RATES[this.pluginName][this.currency];
        }
    }

    return exchangeRate;
};

Payments.prototype.convertPrice = function (price) {
    const exchangeRate = this.getExchangeRate();

    if (exchangeRate === 1) {
        return price;
    }

    return Math.max(Math.floor(price * exchangeRate + 0.01), 1);
};

Payments.prototype.getPriceToBePaid = function (product) {
    let price = product.price;

    if (connector.config.debugMode || connector.platform.isTester()) {
        price = 1;
    }

    return price;
};

Payments.prototype.getTextPrice = function (price, currency) {
    // console.warn("getTextPrice", price);

    currency = currency || this.currency;

    const currencySign = Payments.CURRENCY_SIGNS[currency] || currency;

    if (["USD", "GBP", "CNY", "SGD", "KRW", "TWD"].includes(this.currency)) {
        return currencySign + price;
    }

    return `${price} ${currencySign}`;
};

Payments.prototype.getProductId = function () {

};

Payments.prototype.setCurrency = function (currency) {
    if (!connector.EXCHANGE_RATES[currency] && !connector.VIRTUAL_EXCHANGE_RATES[currency]) {
        return;
    }

    if (currency !== this.currency) {
        this.currency = currency;

        for (const key in this.products) {
            const product = this.products[key];

            product.price = this.convertPrice(product.priceUSD);
            product.currency = currency;
            product.textPrice = this.getTextPrice(product.price);
        }
    }
};

Payments.prototype.onRemoved = function () {
    connector._paymentsManager.stop();
};

Payments.prototype.setPurchaseState = function (purchaseState) {
    if (this.purchaseState !== purchaseState) {
        this.purchaseState = purchaseState;

        if (this.purchaseState === undefined) {
            this.bus.trigger("paymentClosed");
        }
    }
};

Payments.prototype.isIdle = function () {
    return this.purchaseState === undefined;
};

Payments.prototype.getPurchaseState = function () {
    return this.purchaseState;
};

Payments.prototype.restore = function (callback) {
    callback(connector.CODE_FAILED);
};

Payments.prototype.consume = function (purchase, callback) {
    callback(connector.CODE_SUCCEED);
};

Payments.prototype.purchase = function (product, callback) {
    callback(connector.CODE_FAILED);
};

Payments.prototype.validate = function (purchase, callback) {
    callback(connector.CODE_SUCCEED, purchase);
};

Payments.prototype.createPurchase = function (paymentId, product, payload) {
    const userId = String(connector.platform.getUserID())
        .replace("sb.mbga.jp:", "")
        .replace("mbga.jp:", "")
        .replace("FS_", "");

    const purchase = {
        userId,
        productId: product.productId,
        source: connector.info.source,
        method: this.pluginName,
        price: this.getPriceToBePaid(product),
        realPrice: connector._paymentsManager.calcRealUSDPrice(product),
        currency: product.currency || "USD",
        type: product.type,
        payload: payload || {}
    };

    if (paymentId) {
        purchase.paymentId = String(paymentId);
    }

    return purchase;
};

Payments.prototype.getSubscriptionStatus = function (options, callback) {
    const source = connector.info.source;
    if (["android", "ios", "macos"].includes(source) && Object.keys(options.tokens).length === 0) {
        return;
    }

    if (connector.platform.withTmpID() && source === "ok") {
        return;
    }

    const params = { source, tokens: options.tokens };

    ConnectorRestClient.post(`/subscriptions/get/${encodeURIComponent(connector.platform.getUserID())}`, params, callback);
};

Payments.prototype.loadProducts = function (callback) {
    if (this.productsLoaded) {
        callback(connector.CODE_SUCCEED);
        return;
    }

    const retryOnMissingProducts = this.oneOf(connector.INSTANT, connector.SAMSUNG);

    this._loadProducts((code, loadedIds) => {
        if (code !== connector.CODE_SUCCEED || loadedIds.length === 0) {
            callback(connector.CODE_FAILED);
            this.bus.trigger("productsFailed");
            return;
        }

        const missingProducts = this._getMissingProducts(["consumable", "nonConsumable"], loadedIds);

        if (missingProducts.length > 0 && retryOnMissingProducts
            && (this.missingProductsLoadAttempt || 0) < Payments.MISSING_PRODUCTS_LOAD_ATTEMPTS) {
            this.missingProductsLoadAttempt = (this.missingProductsLoadAttempt || 0) + 1;
            callback(connector.CODE_FAILED);
            this.bus.trigger("productsFailed");
            return;
        }

        if (missingProducts.length === 0 && this.missingProductsLoadAttempt) {
            connector.metrics.logEvent(connector.EVENTS.STATS.PAYMENTS_MISSING_PRODUCTS_RECOVERED + this.missingProductsLoadAttempt);
        }

        this.productsLoaded = true;

        this.verifyLoadedProducts(loadedIds);
        this.bus.trigger("productsLoaded");

        callback(code);
    });
};

Payments.prototype._loadProducts = function (callback) {
    const loadedIds = this.listProductIdsOfType(["consumable", "nonConsumable"]);

    callback(connector.CODE_SUCCEED, loadedIds);
};

Payments.prototype.loadSubscriptions = function (callback) {
    if (this.subscriptionsLoaded) {
        callback(connector.CODE_SUCCEED);
        return;
    }

    const subscriptionsIds = this.listProductIdsOfType("subscription");

    if (subscriptionsIds.length === 0) {
        this.subscriptionsLoaded = true;
        callback(connector.CODE_SUCCEED);
        return;
    }

    this._loadSubscriptions((code, loadedIds) => {
        if (code !== connector.CODE_SUCCEED) {
            callback(code);
            return;
        }

        if (loadedIds.length > 0) {
            this.subscriptionsLoaded = true;
        }

        this.verifyLoadedSubscriptions(loadedIds);

        callback(code);
    });
};

Payments.prototype._loadSubscriptions = function (callback) {
    const loadedIds = this.listProductIdsOfType("subscription");

    callback(connector.CODE_SUCCEED, loadedIds);
};

Payments.prototype.loadSubscriptionsTokens = function (callback) {
    if (this.subscriptionsTokensLoaded) {
        callback(connector.CODE_SUCCEED);
        return;
    }

    const subscriptionsIds = this.listProductIdsOfType("subscription");

    if (subscriptionsIds.length === 0) {
        this.subscriptionsTokensLoaded = true;
        callback(connector.CODE_SUCCEED);
        return;
    }

    this._loadSubscriptionsTokens((code) => {
        if (code === connector.CODE_SUCCEED) {
            this.subscriptionsTokensLoaded = true;
        }

        callback(code);
    });
};

Payments.prototype._loadSubscriptionsTokens = function (callback) {
    callback(connector.CODE_SUCCEED);
};

Payments.prototype.verifyLoadedSubscriptions = function (loadedIds) {
    const missingProducts = this._getMissingProducts("subscription", loadedIds);

    if (missingProducts.length > 0) {
        this.bus.trigger("error:unknownSubscriptions", missingProducts);
    }
};

Payments.prototype.verifyLoadedProducts = function (loadedIds) {
    const missingProducts = this._getMissingProducts(["consumable", "nonConsumable"], loadedIds);

    if (missingProducts.length > 0 && loadedIds.length > 0) {
        this.bus.trigger("error:unknownProducts", missingProducts);
    }
};

Payments.prototype._getMissingProducts = function (types, loadedIds) {
    const productsIds = this.listProductIdsOfType(types);

    return connector.utils.substract(productsIds, loadedIds);
};

Payments.prototype.isRestoreAvailable = function () {
    return connector.payments.isConnected();
};

Payments.prototype.isPaymentIdStable = function () {
    return true;
};

// a purchase the store reported as failed can still be charged and reach us later (a webhook, a pending transaction), so a restore
// is asked soon after the failure and the error window says the purchase will arrive. Measured over 10-12..10-22 2026: 4-22% of
// failed purchases came by a restore within a day on the stores that return true, 0-1.5% on the rest
Payments.prototype.canDeliverLate = function () {
    return false;
};

Payments.prototype.notifyActive = function () {

};

Payments.CURRENCY_SIGNS = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    RUB: "₽",
    CNY: "￥",

    SGD: "S$",
    KRW: "₩",
    TWD: "NT$",
    PLN: "zł",

    MLK: "млк",
    FM: "ФМ"
};

Payments.ERROR_INVALID_EMAIL = "INVALID_EMAIL";
Payments.MISSING_PRODUCTS_LOAD_ATTEMPTS = 2;